const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const gridContainer = path.resolve('src/containers/Grid/index.js')

  return createPage({
    path: router(route.path, {}),
    component: gridContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
